/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { memo } from 'react';
import style from './index.module.less';

import utils from '@/utils/utils';

interface IAudioLoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
}

function AudioLoading(props: IAudioLoadingProps) {
  const { loading = false, className = '', ...rest } = props;
  return (
    <div className={`${utils.isMobile() ? style.loader2 : style.loader} ${className}`} {...rest}>
      {loading && (
        <>
          <div className={style.gif} />
          <div className={style.microphone} />
          <div className={style.gif} />
        </>
      )}
    </div>
  );
}

export default memo(AudioLoading);
